module.exports = __webpack_public_path__ + "img/water5-4.1c1e6081.jpg";